module.exports = __webpack_public_path__ + "img/browser-stats.f4c36826.svg";